/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import Cookies from 'js-cookie';

const TOKEN_NAME = 'token';
const THERMAL_TOKEN_NAME = 'thermalPrinterToken';
const STORE_ID_KEY = 'storeId';
const MODULE_NAME = 'modules';
const ROLE = 'role';
const ADMIN_NAME = 'adminName';
const EMPLOYEE_ID = 'employeeId';
const ADMIN_EMAIL = 'adminEmail';

const setToken = (cvalue: string) => {
  if (!cvalue) {
    return;
  }
  Cookies.set(TOKEN_NAME, cvalue, { expires: 1 });
};

const setThermalPrinterToken = (cvalue: string) => {
  if (!cvalue) {
    return;
  }
  Cookies.set(THERMAL_TOKEN_NAME, cvalue, { expires: 1 });
};

const setModulePermissionList = (cvalue: string) => {
  if (!cvalue) {
    return;
  }
  localStorage.setItem(MODULE_NAME, JSON.stringify(cvalue));
};

const setStoreId = (cvalue: string) => {
  if (!cvalue) {
    return;
  }
  Cookies.set(STORE_ID_KEY, cvalue, { expires: 1 });
};

const setRole = (roleValue: string) => {
  localStorage.setItem(ROLE, roleValue);
};

const setAdminProfile = (profile: {
  name?: string;
  employeeId?: string;
  role?: string;
  email?: string;
}) => {
  if (profile.name) {
    localStorage.setItem(ADMIN_NAME, profile.name);
  }
  if (profile.employeeId) {
    localStorage.setItem(EMPLOYEE_ID, profile.employeeId);
  }
  if (profile.email) {
    localStorage.setItem(ADMIN_EMAIL, profile.email);
  }
  if (profile.role) {
    setRole(profile.role);
  }
};

const getToken = (url = '') => Cookies.get(TOKEN_NAME);
const getThermalToken = (url = '') => Cookies.get(THERMAL_TOKEN_NAME);
const getStoreId = () => Cookies.get(STORE_ID_KEY);
const getModulePermission = () => localStorage.getItem(MODULE_NAME);
const getRole = () => localStorage.getItem(ROLE);
const getAdminName = () => localStorage.getItem(ADMIN_NAME);
const getEmployeeId = () => localStorage.getItem(EMPLOYEE_ID);
const getAdminEmail = () => localStorage.getItem(ADMIN_EMAIL);

const deleteToken = () => {
  Cookies.remove(TOKEN_NAME);
  Cookies.remove(STORE_ID_KEY);
  localStorage.clear();
};

export {
  setToken,
  setThermalPrinterToken,
  setStoreId,
  getToken,
  deleteToken,
  getThermalToken,
  getStoreId,
  setModulePermissionList,
  getModulePermission,
  setRole,
  getRole,
  setAdminProfile,
  getAdminName,
  getEmployeeId,
  getAdminEmail,
};
